import type { App } from "@open-booking/server";
import { createApi } from "@reduxjs/toolkit/query/react";
import { type EdenCall, edenBaseQuery } from "@/src/common/lib/eden-base-query";

type GetBookingPaymentsResponse = App["~Routes"]["bookings"][":id"]["payments"]["get"]["response"]["200"];

export const paymentApi = createApi({
	reducerPath: "paymentApi",
	baseQuery: edenBaseQuery(),
	tagTypes: ["BookingPayments"],
	endpoints: (builder) => ({
		getBookingPayments: builder.query<GetBookingPaymentsResponse, string>({
			query:
				(bookingId): EdenCall<GetBookingPaymentsResponse> =>
				(client) =>
					client.bookings({ id: bookingId }).payments.get(),
			providesTags: (_r, _e, id) => [{ type: "BookingPayments", id }],
		}),
	}),
});

export const { useGetBookingPaymentsQuery } = paymentApi;
